import { render } from "./NetworkStatus.vue?vue&type=template&id=110837fa&scoped=true&ts=true"
import script from "./NetworkStatus.vue?vue&type=script&lang=ts"
export * from "./NetworkStatus.vue?vue&type=script&lang=ts"

import "./NetworkStatus.vue?vue&type=style&index=0&id=110837fa&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-110837fa"]])

export default __exports__